import { createApp } from 'vue'
import PracticeSession from '../components/PracticeSession.vue'

export function mountPractice() {
  const el = document.getElementById('practice-app')
  if (!el) return

  let availableTypes = null
  try {
    availableTypes = el.dataset.availableTypes ? JSON.parse(el.dataset.availableTypes) : null
  } catch (e) {
    availableTypes = null
  }

  const app = createApp(PracticeSession, {
    unitId: parseInt(el.dataset.unitId),
    level: el.dataset.level ? parseInt(el.dataset.level) : null,
    exerciseUrl: el.dataset.exerciseUrl,
    unitUrl: el.dataset.unitUrl,
    backUrl: el.dataset.backUrl,
    subscribed: el.dataset.subscribed === 'true',
    speakingFree: el.dataset.speakingFree === 'true',
    availableTypes,
    nextUnitUrl: el.dataset.nextUnitUrl || null,
    nextUnitTitle: el.dataset.nextUnitTitle || null,
    nextUnitPosition: el.dataset.nextUnitPosition ? parseInt(el.dataset.nextUnitPosition) : null,
    nextUnitLocked: el.dataset.nextUnitLocked === 'true',
  })
  app.mount(el)
}
